import type { MouseEvent as ReactMouseEvent } from "react"

type ContentSidebarDividerProps = {
  leftTrack: string
  onMouseDown: (event: ReactMouseEvent<HTMLDivElement>) => void
}

export function ContentSidebarDivider({ leftTrack, onMouseDown }: ContentSidebarDividerProps) {
  return (
    <div
      aria-hidden="true"
      className="absolute top-0 bottom-0 z-70 w-3 -translate-x-1/2 cursor-col-resize"
      style={{ left: leftTrack }}
      onMouseDown={onMouseDown}
    >
      <div className="bg-border/80 hover:bg-primary/70 mx-auto h-full w-px transition-colors" />
    </div>
  )
}
